var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSimpelTruckSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 56 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#simpel-truck-success_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M45.89 32.755h-.634c-3.3-.005-6.316-.244-7.877-.622-1.696-.373-4.773-.603-8.1-.604H9.942C5 31.522.777 31.992.05 32.63c-.275.348.596.695 2.397.955 2.337.292 4.692.428 7.047.407h1.195c3.264.013 6.227.253 7.764.627 1.71.38 4.835.613 8.213.613H46.56c2.365.021 4.728-.115 7.074-.408 1.808-.261 2.683-.61 2.408-.96-.704-.652-5.088-1.131-10.153-1.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M46.2 27.885a2.913 2.913 0 0 0-2.942 2.915c.001.507.138 1.004.395 1.44h-.395v1.476h2.906a2.915 2.915 0 1 0 0-5.83z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M48.995 31.608q.116-.396.123-.809c-.006-.299-.06-.595-.158-.878h-5.505a2.8 2.8 0 0 0-.158.878c0 .274.041.547.123.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M46.205 30.8a2.915 2.915 0 1 0-5.83 0 2.915 2.915 0 0 0 5.83 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCEEE9",
  d: "M22.324 5.838h15.18a6.71 6.71 0 0 1 6.709 6.709v18.262H20.717a1.756 1.756 0 0 1-1.756-1.756V9.193a3.373 3.373 0 0 1 3.372-3.372z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M36.761 12.704h9.026a5.373 5.373 0 0 1 5.374 5.338v11.66a1.106 1.106 0 0 1-1.107 1.106H34.25V15.145a2.476 2.476 0 0 1 2.511-2.441"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M36.4 27.842a2.925 2.925 0 0 0-2.537 4.39h-.386v1.483h2.932a2.94 2.94 0 0 0 2.862-4.099 2.94 2.94 0 0 0-2.862-1.774z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M39.383 31.59c.084-.264.128-.539.131-.816-.01-.3-.066-.596-.166-.878h-5.55c-.097.282-.15.579-.157.878 0 .277.04.552.123.816z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M51.166 24.874h-6.41v-6.831a5.39 5.39 0 0 0-5.382-5.339H34.28V30.8h9.369a1.106 1.106 0 0 0 1.106-1.097v-3.705a.65.65 0 0 1 .65-.65h5.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M25.13 27.886a2.898 2.898 0 0 0-2.52 4.39h-.396v1.475h2.915a2.915 2.915 0 1 0 0-5.83z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M27.918 31.608q.127-.395.131-.809c-.009-.3-.065-.596-.166-.878h-5.497a2.9 2.9 0 0 0-.167.878q.007.413.123.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M24.908 30.8a2.915 2.915 0 1 0-5.83 0 2.915 2.915 0 0 0 5.83 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M15.526 27.842a2.925 2.925 0 0 0-2.537 4.39h-.395v1.483h2.932a2.94 2.94 0 0 0 2.862-4.099 2.94 2.94 0 0 0-2.862-1.774"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M18.508 31.59c.084-.264.128-.539.131-.816-.01-.3-.066-.596-.166-.878h-5.55c-.097.282-.15.579-.157.878 0 .277.04.552.123.816z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2E5DD",
  d: "M9.13 5.838h15.25a6.71 6.71 0 0 1 6.709 6.709V30.81H7.584a1.756 1.756 0 0 1-1.756-1.757V9.131A3.3 3.3 0 0 1 9.13 5.838"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCEEE9",
  d: "M38.26 29.466a1.25 1.25 0 0 1-1.105-.641 4.8 4.8 0 0 0-8.312 0 1.24 1.24 0 0 1-1.105.64H17.574a1.24 1.24 0 0 1-1.104-.64 4.68 4.68 0 0 0-4.157-2.398 4.68 4.68 0 0 0-4.155 2.398 1.25 1.25 0 0 1-1.106.64H5.891A1.87 1.87 0 0 0 7.714 30.8h42.258c.312.004.614-.111.844-.322a1.06 1.06 0 0 0 .346-.784v-.229z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M15.416 30.8a2.915 2.915 0 1 0-5.83 0 2.915 2.915 0 0 0 5.83 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCEEE9",
  d: "M12.596 31.53a.729.729 0 1 0 0-1.458.729.729 0 0 0 0 1.457M44.756 29.694v-.229h-7.71V30.8h6.604a1.106 1.106 0 0 0 1.106-1.106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007261",
  d: "M36.12 30.8a2.915 2.915 0 1 0-5.83 0 2.915 2.915 0 0 0 5.83 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCEEE9",
  d: "M33.159 31.53a.729.729 0 1 0 0-1.458.729.729 0 0 0 0 1.457M51.165 17.848h-9.921a1.213 1.213 0 0 0-1.22 1.212v3.881a1.213 1.213 0 0 0 1.22 1.212h9.921z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2E5DD",
  d: "M44.756 17.848h-4.258a.474.474 0 0 0-.475.474v4.619a1.21 1.21 0 0 0 1.22 1.211h3.513z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCEEE9",
  d: "M51.164 26.84h-8.078a.36.36 0 0 0 0 .72h8.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.754 26.84h-1.668a.36.36 0 0 0 0 .72h1.668zM51.16 26.84h-.957v.72h.957z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D9F4F0",
  d: "M11.463 22.586a2.5 2.5 0 0 0-.403-.223 5 5 0 0 0-.485-.165 2.4 2.4 0 0 1-.566-.22.27.27 0 0 1-.146-.23.24.24 0 0 1 .098-.196.46.46 0 0 1 .288-.077.67.67 0 0 1 .645.462l.89-.522a1.56 1.56 0 0 0-.617-.704c-.28-.165-.6-.249-.925-.243a1.52 1.52 0 0 0-1.027.356 1.17 1.17 0 0 0-.412.93 1.06 1.06 0 0 0 .331.832c.262.22.57.38.9.465q.404.112.522.16.279.113.279.296 0 .279-.485.278a.82.82 0 0 1-.818-.55l-.907.527c.111.312.324.577.604.753.329.196.708.293 1.09.278.41.02.813-.101 1.144-.344a1.15 1.15 0 0 0 .432-.953 1.26 1.26 0 0 0-.106-.537.9.9 0 0 0-.326-.373M13.342 20.557h-1.06v4.147h1.06zM18.22 20.557h-1.055l-.58.968q.803.232 1.634.297z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D9F4F0",
  d: "m16.107 22.329-1.054-1.772h-1.06v4.147h1.06v-2.227l1 1.657h.107l1.007-1.664v2.234h1.055V22.15a6.2 6.2 0 0 1-1.724-.476zM20.494 20.557h-1.611v1.294q.532.009 1.06-.06v-.596l1.259.851-1.259.825v-.598q-.578-.005-1.06-.047v2.477h1.06V23.46h.551a1.46 1.46 0 0 0 1.055-.409 1.38 1.38 0 0 0 .426-1.042 1.38 1.38 0 0 0-.426-1.043 1.47 1.47 0 0 0-1.055-.41M23.443 23.099h1.428v-.978h-1.428v-.574h1.576v-.99h-2.636v4.147h2.666v-.995h-1.606zM26.615 23.68v-3.123h-1.06v4.147h2.488v-1.025z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A88F",
  d: "M18.336 0a8.289 8.289 0 1 1 0 16.577 8.289 8.289 0 0 1 0-16.577"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m21.739 4.659-6.075 6.074 1.572 1.573 6.075-6.075z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.74 8.807 3.112 3.112 1.572-1.572-3.111-3.112z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "simpel-truck-success_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h56v35.177H0z"
})))));
export default SvgSimpelTruckSuccess;